import React, { useEffect, useState } from "react";
import image1 from "../../assets/newsroom/newsroom1.jpeg";
import image2 from "../../assets/newsroom/newsroom2.avif";

import image3 from "../../assets/newsroom/newsroom3.jpg";

import image4 from "../../assets/newsroom/newsroom4.webp";

import image5 from "../../assets/newsroom/newsroom5.webp";

const imageUrls = [image1, image2, image3, image4, image5];

const Item = ({ item, openModal }) => {
  const [isActive, setIsActive] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    const randomImage = imageUrls[Math.floor(Math.random() * imageUrls.length)];

    setImageUrl(randomImage);
  }, []);

  if (typeof item.notification_subject === "string") {
    return (
      <div className=" border-2 border-gray-500 mb-3 relative">
        <img
          loading="lazy"
          className=" w-full object-cover xl:h-100 lg:h-70 md:hidden"
          src={imageUrl}
          alt=""
        />

        {/* my custom design */}
        <div
          className="hidden group relative overflow-hidden md:block"
          onClick={() => {
            setIsActive(!isActive);
            openModal(true, item);
          }}
        >
          <img
            className=" w-full object-cover xl:h-100 lg:h-70"
            src={imageUrl}
            alt=""
          />
          <div className="h-100 absolute w-100 top-0 left-0 opacity-30">
            <div className="absolute bg-blue-400 h-100 w-100 -left-[1000px] group-hover:left-0 transition-all duration-300 mix-blend-overlay"></div>
            <div className="absolute bg-blue-400 h-50 top-25 -right-[1000px] group-hover:right-0 w-100 transition-all duration-300 mix-blend-overlay z-200"></div>
          </div>
          <h4
            className="text-white text-3xl cursor-pointer absolute z-190 
         top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
         hidden group-hover:block drop-shadow-md"
          >
            Read More <i className=" text-base bi bi-arrow-right"></i>
          </h4>
        </div>

        <div className="absolute bottom-0 w-full bg-black/50 xs:p-1 md:p-3">
          {typeof item.notification_subject === "string" &&
            (() => {
              let temp = item.notification_subject.split("-");
              return (
                <div className="grid grid-cols-12 gap-1">
                  <div className="flex col-span-8 items-center justify-start text-base md:text-lg font-semibold  text-white text-bold-100 text-left">
                    {temp[1]}
                  </div>

                  <div
                    onClick={() => {
                      setIsActive(!isActive);
                      openModal(true, item);
                    }}
                    className=" text-orange-300 text-stroke-white font-bold text-base md:text-lg  cursor-pointer col-span-4 flex items-center justify-end"
                  >
                    Read More <i className=" text-base bi bi-arrow-right"></i>
                  </div>
                </div>
              );
            })()}
          {/* 
        {typeof item.notification_subject === "string" &&
          item.notification_subject.indexOf("-") === -1 && (
            <div className="mb-2">{item.notification_subject}</div>
          )}
        {typeof item.notification_subject !== "string" &&
          typeof item.newsletter_due_date === "string" && (
            <div className="flex mt-2 justify-between">
              <h3 className="text-xl">Weekly Newsletter</h3>
              <h3 className="text-gray-500s"> {item.newsletter_due_date} </h3>
            </div>
          )} */}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
};

export default Item;
